module.exports = __webpack_public_path__ + "img/demo_box.67011955.svg";